import * as React from "react";

import { App } from "../../components/App";
import { InitialProps } from "../../store";
import { createStore } from "bundles/UserTitleRoleEditor/store";

export const UserTitleRoleEditorApp = (props: InitialProps) => {
  createStore(props);

  return <App />;
};
